import { TFunction } from "i18next";

import { IMAGE_MAX_BYTES } from "./constants";

const MAX_RICH_TEXT_IMAGES_PER_SAVE = 20;

const FALLBACK_KEY = "media.errors.fallback";

export const MEDIA_ERROR_CODES = {
  UNSUPPORTED_CONTENT_TYPE: "unsupported_content_type",
  SIZE_OUT_OF_RANGE: "size_out_of_range",
  INVALID_MEDIA: "invalid_media",
  TOO_MANY_PENDING_MEDIA: "too_many_pending_media",
  RICH_TEXT_IMAGE_NOT_OWNED: "rich_text_image_not_owned",
  RICH_TEXT_IMAGE_ALREADY_ATTACHED: "rich_text_image_already_attached",
  TOO_MANY_RICH_TEXT_IMAGES: "too_many_rich_text_images",
  CLIENT_PRESIGN_FAILED: "client_presign_failed",
  CLIENT_S3_FAILED: "client_s3_failed",
  CLIENT_S3_NETWORK: "client_s3_network",
} as const;

const CODE_TO_KEY: Record<string, string> = {
  [MEDIA_ERROR_CODES.UNSUPPORTED_CONTENT_TYPE]:
    "media.errors.unsupportedContentType",
  [MEDIA_ERROR_CODES.SIZE_OUT_OF_RANGE]: "media.errors.sizeOutOfRange",

  [MEDIA_ERROR_CODES.INVALID_MEDIA]: "media.errors.invalidMedia",
  [MEDIA_ERROR_CODES.TOO_MANY_PENDING_MEDIA]: "media.errors.tooManyPending",

  [MEDIA_ERROR_CODES.RICH_TEXT_IMAGE_NOT_OWNED]: "media.errors.notOwned",
  [MEDIA_ERROR_CODES.RICH_TEXT_IMAGE_ALREADY_ATTACHED]:
    "media.errors.alreadyAttached",
  [MEDIA_ERROR_CODES.TOO_MANY_RICH_TEXT_IMAGES]: "media.errors.tooMany",

  [MEDIA_ERROR_CODES.CLIENT_PRESIGN_FAILED]: "media.errors.presignFailed",
  [MEDIA_ERROR_CODES.CLIENT_S3_FAILED]: "media.errors.s3Failed",
  [MEDIA_ERROR_CODES.CLIENT_S3_NETWORK]: "media.errors.s3Network",
};

const interpolationFor = (
  code: string,
): Record<string, unknown> | undefined => {
  switch (code) {
    case MEDIA_ERROR_CODES.SIZE_OUT_OF_RANGE:
      return { maxMb: IMAGE_MAX_BYTES / 1024 / 1024 };
    case MEDIA_ERROR_CODES.TOO_MANY_RICH_TEXT_IMAGES:
      return { max: MAX_RICH_TEXT_IMAGES_PER_SAVE };
    default:
      return undefined;
  }
};

export const isMediaErrorCode = (code: string | undefined): boolean =>
  Boolean(code && code in CODE_TO_KEY);

export const translateMediaCode = (
  code: string | undefined,
  t: TFunction,
): string | null => {
  if (!code) return null;
  const key = CODE_TO_KEY[code];
  if (!key) return null;
  return t(key, interpolationFor(code));
};

export const getMediaErrorMessage = (
  code: string | undefined,
  t: TFunction,
): string => translateMediaCode(code, t) ?? t(FALLBACK_KEY);
